import { inputWithOptionsDriverFactory } from '../InputWithOptions/InputWithOptions.driver';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const multiSelectCheckboxDriverFactory = ({ element }) => {
  deprecationTestkitLog(
    'multiSelectCheckboxTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the MultiSelectCheckboxTestkit unidriver testkit instead.',
  );

  const { driver, inputDriver, dropdownLayoutDriver } =
    inputWithOptionsDriverFactory({ element });

  const getLabels = (delimiter = `, `) =>
    inputDriver.getValue().split(delimiter);

  const multiSelectCheckboxDriver = Object.assign(driver, {
    getNumOfLabels: () => getLabels().length,
    getLabels: delimiter => getLabels(delimiter),
    getLabelAt: (index, delimiters) => getLabels(delimiters)[index],
  });

  return {
    exists: () => !!element,
    driver: multiSelectCheckboxDriver,
    inputDriver,
    dropdownLayoutDriver,
  };
};

export { multiSelectCheckboxDriverFactory };
